module.exports = __webpack_public_path__ + "static/img/shopNews_08.db4566f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shopNews_08.png
// module id = 3139
// module chunks = 1